








































































import {
  AnimationsAndTransitionsConfiguration,
  ChoiceAnswerView,
  TransitionStyle,
} from "@zoovu/runner-web-design-base";
import {
  Answer,
  Component,
  InjectComponent,
  Prop,
  VueComponent,
  Vue,
  ComponentConfig,
} from "@zoovu/runner-browser-api";
import { vTooltip } from "@zoovu/design-system/src/plugins";
import { isMobile } from "@zoovu/design-system/src/helpers";
import { sanitize } from "dompurify";
import { AnswerAnimationStyleClass, getAnimationClass } from "../styles/abstract/animation";
import { getTransitionName } from "../styles/abstract/transition";
import { TooltipConfiguration, whitelistedAttributes } from "../types";
import { hideHorizontalOverflow, restoreHorizontalOverflow } from "../services/overflow-service";
import InvisibleWrapper from "./invisible-wrapper.vue";

@Component({
  directives: {
    tooltip: vTooltip.directives.tooltip,
  },
  name: "ChoiceAnswerView",
  mixins: [ChoiceAnswerView],
})
export default class ChoiceAnswerViewExtended extends Vue {
  @InjectComponent("Modal")
  private modal: VueComponent;

  @ComponentConfig(AnimationsAndTransitionsConfiguration)
  animationsAndTransitionsConfiguration: AnimationsAndTransitionsConfiguration;

  @Prop()
  answer: Answer;

  @Prop()
  answerTextHeight: string;

  @Prop()
  imageHeight: string;

  infoTextShown = false;

  isMobile = isMobile();

  minAnswersPerRow = 1;

  transitionDelayEnabled = false;

  get answerIndex(): number {
    return this.answer.question.answers.indexOf(this.answer);
  }

  get answerWrapperStyle(): Record<string, string> {
    return {
      ...(this.transitionDelayEnabled ? { transitionDelay: `${this.answerIndex * 100}ms` } : {}),
      width: this.answerWrapperWidth,
    };
  }

  get animationClass(): AnswerAnimationStyleClass {
    if (this.animationsAndTransitionsConfiguration.animationsEnabled) {
      return getAnimationClass(this.animationsAndTransitionsConfiguration.animationStyle.selected);
    }
    return AnswerAnimationStyleClass.NO_ANIMATION;
  }

  get answerWrapperWidth(): string {
    const numberOfAnswers = this.answer.question.answers.length;
    const maxAllowedAnswersPerRow = 4;
    const perRow = numberOfAnswers < maxAllowedAnswersPerRow ? numberOfAnswers : maxAllowedAnswersPerRow;
    const gutter = 14;
    return `calc( ${100 / perRow}% - ${gutter}px )`;
  }

  get containerDivId(): string {
    return `#${this.$root.containerDivId} > div`;
  }

  get infoTextTooltipConfiguration(): TooltipConfiguration {
    return this.isMobile
      ? {}
      : {
          autoHide: false,
          content: sanitize(this.answer.infoText, { ADD_ATTR: whitelistedAttributes }),
          container: this.containerDivId,
          delay: {
            show: 0,
            hide: 2000,
          },
        };
  }

  get selectedTransitionStyle(): TransitionStyle {
    return this.animationsAndTransitionsConfiguration.transitionStyle.selected;
  }

  get transitionComponent(): string | VueComponent {
    if (
      this.animationsAndTransitionsConfiguration.transitionsEnabled &&
      (this.selectedTransitionStyle === TransitionStyle.SLIDE_LEFT ||
        this.selectedTransitionStyle === TransitionStyle.FADE_AND_SLIDE_LEFT)
    ) {
      return "transition";
    }
    return InvisibleWrapper;
  }

  get transitionName(): string {
    if (this.animationsAndTransitionsConfiguration.transitionsEnabled) {
      return getTransitionName(this.selectedTransitionStyle);
    }
    return "";
  }

  disableTransitionDelay(): void {
    this.transitionDelayEnabled = false;
  }

  enableTransitionDelay(): void {
    this.transitionDelayEnabled = true;
  }

  hideInfoText(): void {
    this.infoTextShown = false;
  }

  onAfterEnter(): void {
    if (this.answerIndex === this.answer.question.answers.length - 1) {
      restoreHorizontalOverflow();
    }

    this.disableTransitionDelay();
  }

  onBeforeEnter(): void {
    if (this.answerIndex === 0) {
      hideHorizontalOverflow();
    }

    this.enableTransitionDelay();
  }

  onInfoTextTriggerClick(): void {
    if (!this.isMobile) return;
    this.showInfoText();
  }

  showInfoText(): void {
    this.infoTextShown = true;
  }
}
